import styled from 'styled-components'

export const MapToggle = styled.div`
  cursor: pointer;
  cursor: hand;
  font-size: 16px;
  outline: 0;
`
